<template>
  <textarea
    :ref="`textInputArea_child_${refId}`"
    rows="1"

    :value="textInput_child"
    :type="inputType"
    :placeholder="placeholder"

    class="input-area no-spinner"
    :class="focusBoxShadow ? `focus-box-shadow-and-border-color-687EFF textInputArea_child_${refId}` : `textInputArea_child_${refId}`"

    @input="textInput_child = $event.target.value; resize()"
  ></textarea>
    <!-- @keyup.enter="keyup_enter" -->
    <!-- @keyup.esc="keyup_esc" -->
    <!-- @keydown.tab.exact.prevent="onTab" -->
    <!-- @keydown.shift.tab.exact.prevent="onShiftTab" -->
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: "TextInputArea",

  props: {
    textInput: {
      type: String,
      default: '',
    },
    inputType: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },

    refId: {
      type: String,
      default: '',
    },

    // style 관련
    focusBoxShadow: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      textInput_child: '',
      readyToEmit: false, // ✅ 초기 세팅 중 emit 막기
    }
  },

  methods: {
    keyup_enter() {
      console.log('keyup_enter')
      this.$emit('set_keyup_enter')
    },
    keyup_esc() {
      console.log('keyup_esc')
      this.$emit('set_keyup_esc')
    },
    onTab() {
      // 부모에게 다음 셀로 이동하라고 알림 (방향: 'next')
      this.$emit('tab-navigation', 'next');
    },
    onShiftTab() {
      // 부모에게 이전 셀로 이동하라고 알림 (방향: 'prev')
      this.$emit('tab-navigation', 'prev');
    },

    resize() {
      const el = this.$refs[`textInputArea_child_${this.refId}`]
      if (el) {
        el.style.height = 'auto'
        el.style.height = el.scrollHeight + 'px'
      }
    },
  },

  created() {
    // console.log('TextInputArea created')
    this.emitDebounced = debounce(v => {
      this.$emit('set_textInput', v)
    }, 150)
  },

  mounted() {
    // console.log('TextInputArea mounted')
    // console.log('textInput', this.textInput)

    this.textInput_child = this.textInput
    // console.log('textInput_child', this.textInput_child)


    this.$nextTick(() => {
      // ✅ 초기 값 세팅 후부터만 emit 허용
      this.readyToEmit = true

      this.resize()
    })
  },

  watch: {
    textInput_child(textInput_child) {
      if (!this.readyToEmit) return // ✅ mounted 초기 동기화는 무시
      this.emitDebounced(textInput_child)
    },

    // (옵션) 부모에서 textInput prop이 바뀌면 input도 동기화하되 emit은 안 함
    textInput(newVal) {
      this.readyToEmit = false
      this.textInput_child = newVal
      this.$nextTick(() => {
        this.readyToEmit = true
      })
    },
  },
  
}
</script>

<style>

</style>